// components
import BackButton from "components/shared/BackButton";
import DrawerCM from "components/shared/Drawer";

// hooks
import useHttp from "hooks/use-http";
import { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

// mui cm
import { Button, Grid, Tooltip } from "@mui/material";

// styled cm
import {
  ButtonContainer,
  StyledDataText,
  StyledDataTitle,
  StyledGrid,
  StyledStack,
  StyledTitle,
} from "./UserInfo.style";

// mui icon
import LockResetIcon from "@mui/icons-material/LockReset";
import { getUserInfoRequest } from "api/requests";
import { Download } from "@mui/icons-material";
import { FILE_BASE_URL } from "constants";
import LoadingCM from "components/shared/Loading";
import { Fragment } from "react";
import spliter from "helper/digit-spliter";

export default function TeacherProfile() {
  const { loading, request } = useHttp(false);

  const navigate = useNavigate();

  const [userData, setUserData] = useState(null);

  const getUserInfo = useCallback(async () => {
    const res = await request({
      url: getUserInfoRequest,
    });
    if (res) {
      setUserData(res.data);
    }
  }, []);

  useEffect(() => {
    getUserInfo();
  }, [getUserInfo]);

  return (
    <DrawerCM title="پنل مدرس" $styledHeader>
      {loading ? (
        <LoadingCM />
      ) : (
        <Fragment>
          {/* <Grid item xs={12} my={3}>
            <BackButton />
          </Grid> */}
          <StyledStack>
            <StyledTitle>اطلاعات مدرس</StyledTitle>
            {userData ? (
              <Fragment>
                <Grid container>
                  <StyledGrid item lg={4} md={6} xs={12}>
                    <StyledDataTitle>نام و نام خانوادگی</StyledDataTitle>
                    <StyledDataText>
                      {userData.first_name} {userData.last_name}
                    </StyledDataText>
                  </StyledGrid>
                  <StyledGrid item lg={4} md={6} xs={12}>
                    <StyledDataTitle>کد ملی</StyledDataTitle>
                    <StyledDataText>{userData.national_code}</StyledDataText>
                  </StyledGrid>
                  <StyledGrid item lg={4} md={6} xs={12}>
                    <StyledDataTitle>شماره تماس</StyledDataTitle>
                    <StyledDataText>{userData.mobile_number}</StyledDataText>
                  </StyledGrid>
                  <StyledGrid item lg={4} md={6} xs={12}>
                    <StyledDataTitle>کد پرسنلی</StyledDataTitle>
                    <StyledDataText>
                      {userData.personnel_code ?? "ثبت نشده"}
                    </StyledDataText>
                  </StyledGrid>
                  <StyledGrid item lg={4} md={6} xs={12}>
                    <StyledDataTitle> مدرک تحصیلی</StyledDataTitle>
                    <StyledDataText>
                      {userData.degree_of_education ?? "ثبت نشده"}
                    </StyledDataText>
                  </StyledGrid>
                  <StyledGrid item lg={4} md={6} xs={12}>
                    <StyledDataTitle>شماره حساب</StyledDataTitle>
                    <StyledDataText>
                      {userData.account_number ?? "ثبت نشده"}
                    </StyledDataText>
                  </StyledGrid>
                  <Grid item lg={4} md={6} xs={12} p={1}>
                    {userData.degree_education_file && (
                      <Tooltip title="دانلود" followCursor placement="top">
                        <Button
                          fullWidth
                          sx={{ display: "flex", justifyContent: "start" }}
                          download
                          href={FILE_BASE_URL + userData.degree_education_file}
                          endIcon={<Download />}
                        >
                          {" "}
                          دانلود مدرک تحصیلی{" "}
                        </Button>
                      </Tooltip>
                    )}
                  </Grid>
                  <Grid item lg={4} md={6} xs={12} p={1}>
                    {userData.id_document_file && (
                      <Tooltip title="دانلود" followCursor placement="top">
                        <Button
                          fullWidth
                          sx={{ display: "flex", justifyContent: "start" }}
                          download
                          href={FILE_BASE_URL + userData.id_document_file}
                          endIcon={<Download />}
                        >
                          {" "}
                          دانلود مدرک شناسایی
                        </Button>
                      </Tooltip>
                    )}
                  </Grid>
                </Grid>
                <ButtonContainer>
                  <Button
                    variant="contained"
                    endIcon={<LockResetIcon fontSize="large" />}
                    onClick={() => navigate("/teacher/get_otp")}
                  >
                    {" "}
                    ویرایش گذرواژه
                  </Button>
                </ButtonContainer>
              </Fragment>
            ) : (
              <StyledDataText>اطلاعات یافت نشد</StyledDataText>
            )}
          </StyledStack>
        </Fragment>
      )}
    </DrawerCM>
  );
}
